import { StratumService, WINDOW_DEBUG_FLAG_KEY } from '@cof/stratum';
import { PRODUCT_NAME, PRODUCT_VERSION, TAG_CATALOG, PLUGINS } from '@cof/tag-catalog-fs-esign-mfe';
import { RefiSharedAnalyticsService } from '@cof/refi-web-sdk';
import { REFI_ESIGN_CONST } from './app.constants.js';
import { DebugService } from '../app/shared/services/debug.service.js';

export const stratum = new StratumService(TAG_CATALOG, {
  productName: PRODUCT_NAME,
  productVersion: PRODUCT_VERSION,
  plugins: PLUGINS,
});

if (!REFI_ESIGN_CONST.isProdEnv) {
  window[WINDOW_DEBUG_FLAG_KEY] = true;
  const debug = new DebugService('StratumService');

  stratum.addEventListener(event => {
    debug.log('Stratum Event Received', event);
  });
}

const customEvents = new Map();
customEvents.set('gen3-tracker', '1008');

export const sharedAnalytics = new RefiSharedAnalyticsService(stratum, REFI_ESIGN_CONST.isProdEnv, customEvents);
